import React, { useState, useContext, forwardRef } from 'react'
import { Button, Modal, RadioGroup } from '@ow/comps'
import OrgContext from '../../hooks/org/context'

const ConfigRole = function ({ userIds, closeModal, useUserApi }, ref) {
  const { roles } = useContext(OrgContext)
  const { userOperate } = useUserApi
  const { configRole } = userOperate || {}
  const [roleId, setRoleId] = useState(null)

  const onClickConfigRole = () => {
    configRole(userIds, roleId, () => {
      if (closeModal) {
        closeModal()
      }
    })
  }

  return (
    <Modal
      ref={ref}
      title="配置角色"
      size="md"
      showCloseButton
      // eslint-disable-next-line react/no-unstable-nested-components
      footer={() => {
        return (
          <div className="w-full flex flex-row justify-end gap-2">
            <Button
              customStyle="mr-2"
              stroke
              onClick={() => {
                if (closeModal) {
                  closeModal()
                }
              }}
            >
              取消
            </Button>
            <Button
              disabled={roleId === null}
              customStyle="button w-20 bg-blue-1 text-white"
              onClick={onClickConfigRole}
              type="primary"
            >
              确定
            </Button>
          </div>
        )
      }}
    >
      <div className="w-full flex flex-col p-5">
        <RadioGroup
          name="roles"
          options={(roles || []).map((v) => {
            return { ...v, value: v.id }
          })}
          onChange={(e) => {
            setRoleId(e.target.value)
          }}
        />
      </div>
    </Modal>
  )
}

export default forwardRef(ConfigRole)
